export default __webpack_public_path__ + "255f4ff41af8567b71d3fe442fcf7cc3.svg";